import type { AgentOwner as AgentOwnerModel } from '@/adapters/catalogv1.g';

export function extractAgentOwner(model: AgentOwnerModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    agentRef: model.agent_ref ?? '',
    ownerAccountRef: model.owner_account_ref ?? '',
    // owner is a platform-recorded assignment; creator is inferred from an
    // audit record. A reader has to be able to tell them apart.
    ownershipKind: model.ownership_kind ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentOwner = ReturnType<typeof extractAgentOwner>;
